import { defineComponent, reactive, watch, computed } from 'vue';
import axios from 'axios';
import _ from 'lodash';
import { HomeApplianceService } from '@hems/service';
import ApplianceChartByDeviceContainer from '@hems/user/src/containers/homeAppliance/ApplianceChartByDeviceContainer.vue';
import { AxiosErrorException } from '@hems/util/src/exception/exception';
import { ApplianceCurrentValueBox, ApplianceStatusBox, ApplianceControlBox } from '@/components';
import { APPLIANCE_TYPE } from '@/config/constants';
const SMARTTHINGS_API_BASE_URL = process.env.VUE_APP_SMARTTHINGS_API_URL;
export default defineComponent({
    name: 'ApplianceDetailContainer',
    components: {
        ApplianceCurrentValueBox,
        ApplianceStatusBox,
        ApplianceControlBox,
        ApplianceChartByDeviceContainer,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    emits: ['control'],
    async setup(props, { emit }) {
        const homeApplianceService = new HomeApplianceService(window.axiosInstance.axios);
        const state = reactive({
            tabName: 'main',
            show: false,
        });
        const homeApplianceDetail = computed(() => props.data);
        const isCurrentValue = computed(() => (props.data.currentValue || props.data.indoor.currentValue) ?? false);
        const isSubTab = computed(() => props.data.profile_cd === APPLIANCE_TYPE.HEAT_PUMP ?? false);
        const isEmpty = computed(() => _.isEmpty(homeApplianceDetail.value));
        function onClickTab(tabName) {
            state.tabName = tabName;
        }
        watch(() => props.data, () => {
            state.tabName = 'main';
            state.show = true;
        });
        // control
        const onSave = async (params, applianceItem) => {
            const authToken = await checkAuthStatus(applianceItem);
            try {
                const axiosInstance = axios.create({
                    baseURL: SMARTTHINGS_API_BASE_URL,
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                });
                const homeApplianceService = new HomeApplianceService(axiosInstance);
                await homeApplianceService.controlAppliance(applianceItem.device_id, params);
                state.show = false;
                emit('control');
            }
            catch (e) {
                console.error(e);
                return false;
            }
        };
        const checkAuthStatus = async (applianceItem) => {
            try {
                const axiosInstance = axios.create({
                    baseURL: SMARTTHINGS_API_BASE_URL,
                    headers: {
                        Authorization: `Bearer ${applianceItem.auth_token}`,
                    },
                });
                const homeApplianceService = new HomeApplianceService(axiosInstance);
                await homeApplianceService.getApplianceInfo(applianceItem.device_id);
                return applianceItem.auth_token;
            }
            catch (e) {
                console.error(e);
                if (e instanceof AxiosErrorException) {
                    e.afterError({
                        401: async () => {
                            return await getRefreshToken(applianceItem.auth_token);
                        },
                    });
                }
                return '';
            }
        };
        const getRefreshToken = async (authToken) => {
            try {
                const res = await homeApplianceService.refreshSmartThingsToken(authToken);
                return res.access_token;
            }
            catch (e) {
                console.error(e);
                return '';
            }
        };
        return {
            state,
            APPLIANCE_TYPE,
            onSave,
            onClickTab,
            isEmpty,
            homeApplianceDetail,
            isCurrentValue,
            isSubTab,
        };
    },
});
